import { Component, OnDestroy, OnInit } from '@angular/core';
import { DirectEditService } from '@app/modules/direct/services/direct-edit.service';
import { DirectService } from '@app/modules/direct/services/direct.service';
import { DeviceDetectionService } from '@app/shared/services/device-detection/device-detection.service';
import { Subject, takeUntil } from 'rxjs';

@Component({
  selector: 'sbnb-direct-edit-site-header',
  templateUrl: './direct-edit-site-header.component.html',
  styleUrl: './direct-edit-site-header.component.scss',
})
export class DirectEditSiteHeaderComponent implements OnInit, OnDestroy {
  title = '';
  saveStatus: number;
  destroy$ = new Subject<void>();

  $isMobile = this.deviceDetectionService.isMobileViewport();

  constructor(
    public readonly directEditService: DirectEditService,
    private readonly direct: DirectService,
    private readonly deviceDetectionService: DeviceDetectionService
  ) {}

  ngOnInit() {
    this.directEditService.site$.pipe(takeUntil(this.destroy$)).subscribe((site) => (this.title = site?.title || ''));
  }

  ngOnDestroy(): void {
    this.destroy$.next();
  }

  saveTitle() {
    this.saveStatus = 1;
    this.direct.updateSite(this.directEditService.site.id, { title: this.title }).subscribe(
      () => {
        this.saveStatus = 2;
        this.directEditService.setSite({ title: this.title });

        setTimeout(() => {
          this.saveStatus = 0;
        }, 2000);
      },
      () => {
        this.saveStatus = -1;
      }
    );
  }
}
